import {Component, inject, model, output} from '@angular/core';
import {Router} from '@angular/router';
import {DialogComponent} from '@components/dialogs/dialog/dialog.component';
import {IconBoldCloseSquareComponent} from '@components/icons/icon-bold-close-square/icon-bold-close-square.component';
import {IconBoldRam2Component} from '@components/icons/icon-bold-ram-2/icon-bold-ram-2.component';
import {
  InputSelectTipoObra
} from '@pages/demandas/adicionar-demanda/input-select-tipo-obra/input-select-tipo-obra.component';
import {Button} from 'primeng/button';

@Component({
  selector: 'app-selecionar-tipo-obra-dialog',
  imports: [
    Button,
    DialogComponent,
    InputSelectTipoObra,
    IconBoldCloseSquareComponent,
    IconBoldRam2Component
  ],
  templateUrl: './selecionar-tipo-obra-dialog.component.html',
  styleUrl: './selecionar-tipo-obra-dialog.component.css'
})
export class SelecionarTipoObraDialog {
  visible = model(false);
  tipoObraSelected = output<number>();

  private readonly router = inject(Router);

  protected selectedTipoObraId!: number;

  onTipoObraChange(id: number | null) {
    if (id) {
      this.selectedTipoObraId = id;
    }
  }

  confirmarTipoObra() {
    this.tipoObraSelected.emit(this.selectedTipoObraId);
    this.visible.set(false);
  }

  protected cancelarTipoObra() {
    this.visible.set(false);
    this.router.navigate(['/demandas/mapa']);
  }
}
